<template>
	<div class="text">
		<p>注 1:每逢半年度时会做一定调整，具体调整金额以芝麻招工!
			官方的邮件或公告为准，调整后的金额对于已签约用户不受影响。</p>
		<p>注 2:为方便“蓝领经纪人会员”的销售，平台会为每位超级
			经纪人免费提供 6 张“蓝领经纪人”试用月卡使用权限，该
			权限仅用于试用，不得兑现或变相 销售;平台同时会根据每
			个超级经纪人的销售额，上调月度免费提供试用月卡的 数量，
			具体为:每销售 1 张月卡，多赠送 3 张试用月卡，每销售 1
			张半年卡或者 年卡，多赠送 6 张试用月卡。</p>
		<p>注 3:“月月长返”项目指的是 BPO 类项目，每月产生服务费，
			费用则按岗位具体约定，在平台上每月返佣。</p>
		<p>注 4:芝麻招工每年会召开芝麻招工 VIP 会员的年度盛典，届
			时将邀请行业达人为会员们分享行业经验和介绍资源。如遇
			疫情等特殊情况，年度盛典将会另外择期举行。</p>
		<p>注 5:在 2022 年 7 月 1 日~2023 年 6 月 30 日期间，蓝领
			经纪人的销售额，按 50%提成。</p>
		<p>注 6:售出的每个蓝领经纪人账号，需完成 1 人次有效入职返
			佣后，方可视为有效销售额(下文同)，其上级的超级经纪人
			方可计算提成。</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '经纪人注释'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
